import { IGetRemainingDeliveryStatus } from "../../utils/types";
import { apiManager } from "../api-manager";

export const getRemainingDeliveries = async (
  userId: string,
) => {
  const res = await apiManager.post<IGetRemainingDeliveryStatus>(
    "/remaining-deliveries/remaining-deliveries-status",
    {
      userId,
      subscriptionRequest:"admin",
    }
  );
  return res;
};
